import React, {useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import _ from 'lodash';
import UpdateTab from "../../components/updateTab";
import {requestGetLastUpdatePolicyForm} from "../../actions/applicationsAndPolicies";
import {
    changeUpdatePolicyField,
    changeUpdatePolicyFormData,
    getUpdateTabTagsDescription,
    prePopulateUpdateFormField,
    requestGetAllPreviousUpdates,
    requestGetUpdateQuestions,
    requestPostNoChangesUpdatePolicyForm,
    requestPostUpdatePolicyForm,
    updatePolicyAttachmentsChange
} from "../../actions/updateTab";
import {DATE_REGURAL_EXPRESSION, CANADA_COUNTRY, COUNTRY, ARAG_USER_CAN_SUBMIT_UPDATE_FORM} from "../../helpers/variables";
import {fileToObjectHandle, getHtmlValidDate, isSolicitorUser, isValidEmail, TERMINAL_POLICY_STATUSES} from "../../helpers/functions";
import moment from "moment";
import {
    arrayUnique,
    findQuestionById,
    getDateQuestionMaximumValue,
    getDateQuestionMinimumValue
} from "../../helpers/questions/functions";
import {
    findUpdateQuestionById
} from "../../helpers/updateTab/functions";
import {fetchApplicationByIdAfterApplicationUpdate} from "../../actions/newApplication";
import {
    POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL, POLICY_UPDATE_QUESTION_MN_LAWYERS_EMAIL_ADDRESS,
    POLICY_UPDATE_QUESTION_CA_MN_REASON_CASE_REPRESENTATION_CHANGED,
    POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL_INTERNAL, POLICY_UPDATE_OPT_MN_INTERNAL_TRANSFER,
    CONFIRM_FEE_EARNER_CURRENTLY_RESPONSIBLE_MN,
    FEE_EARNER_EMAIL_MN,
    IS_CASE_CLOSED_MN,
    CURRENT_LITIGATION_STAGE_MN,
    OTHER_RESULT_INFO_MN,
    HAS_LAWYER_CHANGED_SINCE_LAST_UPDATE_MN,
    CONFIRM_DEFENDANTS_INSURERS_MN,
    NAME_OF_INSURER_MN,
    BAD_MSG,
    SOLICITOR,
    REQUEST_UPDATE,
    MOMENT_DATE_FORMAT,
    NOT_VALID_MAIL,
    NAME_FIELD
} from "../../helpers/constants";
import {validateAmount} from "../../helpers/functions";
import {INPUT_TYPE} from "../../helpers/formGroupVariants";
import { isAragUser } from '../../helpers/functions';
import CONTENT_STRINGS from '../../helpers/contentStrings';

const UpdateTabHOC = () => {
    const dispatch = useDispatch();

    // useSelector for state
    const router = useSelector(state => state.router);
    const updateTab = useSelector(state => state.updateTab);
    const user = useSelector(state => state.user);
    const applicationPolicyAgentName = useSelector(state => state.newApplication.selectedApplication.agentName);
    const applicationPolicyAgentEmail = useSelector(state => state.newApplication.selectedApplication.agentEmail);
    const applicationPolicyId = useSelector(state => state.newApplication.selectedApplication.id);
    const applicationStatusMachineName = useSelector(state => state.newApplication.selectedApplication.policyStatusMachineName);
    const UserRole = useSelector(state => state.user.loggedInUser.roles[0]);
    const SelectedAppId = useSelector(state => state.newApplication.selectedApplication.id);
    const hasProcessingAd = useSelector(state => state.newApplication.selectedApplication.hasProcessingAdvanceDisbursements);
    // WI 95280: read here and passed down, rather than read inside PolicyTabUpdateQuestion, because that
    // component is shared with the External Policy update modal which is driven by a different slice.
    const pigApplied = useSelector(state => !!state.newApplication.selectedApplication?.pig?.alreadyApplied);

    const prevUpdateTabRef = useRef();

    // componentWillMount equivalent
    useEffect(() => {
        const route = router.location.pathname;
        const splitedRoute = _.split(route, '/', 4);
        const splitId = splitedRoute[3];
        dispatch(requestGetAllPreviousUpdates(splitId));
        dispatch(requestGetUpdateQuestions(splitId));
        dispatch(requestGetLastUpdatePolicyForm(splitId));
        if (isSolicitorUser(user.loggedInUser.roles) || (isAragUser(user.loggedInUser.roles) && ARAG_USER_CAN_SUBMIT_UPDATE_FORM)) {
            dispatch(getUpdateTabTagsDescription());
        }
    }, []);

    // componentWillReceiveProps equivalent
    useEffect(() => {
        const prevUpdateTab = prevUpdateTabRef.current;

        if (prevUpdateTab) {
            // Pre-populate form fields
            if(
                (prevUpdateTab.fetching || prevUpdateTab.fetchingAllPreviousUpdates) &&
                (!updateTab.fetching && !updateTab.fetchingAllPreviousUpdates) &&
                (updateTab.previousUpdates.length === 0)
            ){
                dispatch(prePopulateUpdateFormField({
                    questionMachineName: CONFIRM_FEE_EARNER_CURRENTLY_RESPONSIBLE_MN,
                    value: applicationPolicyAgentName
                }));
                dispatch(prePopulateUpdateFormField({
                    questionMachineName: FEE_EARNER_EMAIL_MN,
                    value: applicationPolicyAgentEmail
                }));
            }

            // Fetch application/policy after receiving successful policy update response
            if(
                !updateTab.posting && prevUpdateTab.posting
                && !updateTab.badMsg
            ) {
                dispatch(fetchApplicationByIdAfterApplicationUpdate({
                    applicationId: applicationPolicyId
                }))
            }
        }

        prevUpdateTabRef.current = updateTab;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateTab, applicationPolicyAgentName, applicationPolicyAgentEmail, applicationPolicyId, dispatch]);

    const _getPolicyUpdateAnswersDto = (questionId, answer) => {
        const question = _.find(updateTab.questions, qItem => {
            return qItem.id === parseInt(questionId);
        });
        if(question.inputType === INPUT_TYPE.TEXT){ 
            return {
                questionId: questionId,
                optionId: null,
                text: answer,
                amount: null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === INPUT_TYPE.AMOUNT){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: answer,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === INPUT_TYPE.TEXT_AREA){
            return {
                questionId: questionId,
                optionId: null,
                text: answer,
                amount: null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === INPUT_TYPE.DROP_DOWN){
            const option = _.find(question.options, option => {
                return option.id.toString() === answer.toString()
            });
            return {
                questionId: questionId,
                optionId: answer,
                text: null,
                amount: null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                optionMachineName: option?option.machineName:null,
                inputType: question.inputType,
            }
        }
        if(question.inputType === INPUT_TYPE.CALENDAR){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: null,
                date: answer ? moment(answer, MOMENT_DATE_FORMAT).format() : null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === INPUT_TYPE.MULTI_UPLOAD){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: null,
                answerAttachments:answer,
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === INPUT_TYPE.UPLOAD){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: null,
                answerAttachments:answer,
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
    };

    const _getAnswerForParentQuestionReason = (updateTabData) => {
        const formDataAnswers = _.pickBy(updateTabData.formData, (item) => item);
        const policyUpdateAnswersDtos = _.map(formDataAnswers, (fdItem, key) => _getPolicyUpdateAnswersDto(key, fdItem));
        return policyUpdateAnswersDtos.find(answer =>
            answer.questionMachineName === POLICY_UPDATE_QUESTION_CA_MN_REASON_CASE_REPRESENTATION_CHANGED
        );
    };

    const _getEmailQuestion = (updateTabData) => {
        let feeEarnerEmailMachineName = POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL;
        //Check if IsCaseTransferred Or InternalTransfer for canada
        if (COUNTRY === CANADA_COUNTRY) {
            const answerForParentQues = _getAnswerForParentQuestionReason(updateTabData);
            feeEarnerEmailMachineName =answerForParentQues &&  answerForParentQues.optionMachineName === POLICY_UPDATE_OPT_MN_INTERNAL_TRANSFER ? POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL_INTERNAL : POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL;
        }
        return updateTabData.questions.find(
            (e) => e.machineName === feeEarnerEmailMachineName || e.machineName === POLICY_UPDATE_QUESTION_MN_LAWYERS_EMAIL_ADDRESS
        );
    };

    const isValidEmailAddress = () => {
        const emailQuestion = _getEmailQuestion(updateTab);
        const emailValue = updateTab.formData[parseInt(emailQuestion.id)];

        if (COUNTRY === CANADA_COUNTRY) {
            if(!emailQuestion.isRequired && !emailValue)
                return true;
            else if (emailValue && !isValidEmail(emailValue))
                return false;
        }
        else if (emailValue && !isValidEmail(emailValue))
            return false;

        return true;
    };


    const handleUpdateTabSubmit = (evt, action) => {
        evt.preventDefault();
        let policyUpdateAnswersDtos = [];
        let sendBody = {};
        let formData = updateTab.formData;
        let attachments = updateTab.attachments;
        if (action === REQUEST_UPDATE) {
            // Request Update button - send simple notification
            dispatch(requestPostUpdatePolicyForm({
                applicationId: SelectedAppId,
                sendEmail: updateTab.sendEmailNotification,
                action: action
            }));
        }
        else if (user.loggedInUser.roles[0] === SOLICITOR || (isAragUser(user.loggedInUser.roles) && ARAG_USER_CAN_SUBMIT_UPDATE_FORM)) {
            if (action === '') {
                let valid = true;

                if (!isValidEmailAddress())
                    {
                    valid = false;
                    dispatch(changeUpdatePolicyField(NOT_VALID_MAIL, CONTENT_STRINGS.EMAIL_ADDRESS_NOT_VALID));
                    dispatch(changeUpdatePolicyField(BAD_MSG, CONTENT_STRINGS.EMAIL_ADDRESS_NOT_VALID))
                }
                if (valid) {
                    // filter answers - include only changed answers and answered questions
                    let formDataAnswers = _.pickBy(updateTab.formData, (item, key) => {
                        if(item){
                            return item;
                        }

                        // if null answer check if previous answer of question existed and changed
                        const matchedQuestion = updateTab.questions.find(q =>
                            q.id
                            && key
                            && q.id.toString() === key.toString()
                        );
                        if(!matchedQuestion){
                            return  false;
                        }

                        const matchedQuestionAnswer = (
                            updateTab.updatePolicy
                            && updateTab.updatePolicy.policyUpdateAnswersDtos
                        )
                            ? (
                                updateTab.updatePolicy.policyUpdateAnswersDtos.find(answer =>
                                    answer.questionId
                                    && matchedQuestion.id
                                    && matchedQuestion.id.toString() === answer.questionId.toString()
                                )
                            )
                            : null;

                        if(!matchedQuestionAnswer){
                            return false;
                        }
                        if(
                            matchedQuestionAnswer.text
                            || matchedQuestionAnswer.amount
                            || matchedQuestionAnswer.date
                        ) {
                            return true;
                        }

                        return false
                    });
                    // map answer to answerDTO acceptable from the api
                    policyUpdateAnswersDtos = _.map(formDataAnswers, (fdItem, key) => ( _getPolicyUpdateAnswersDto(key, fdItem) ) );
                    let invalidDates = _.filter(policyUpdateAnswersDtos, item => {
                        if(item.date){
                            if(!moment(item.date).isValid()){ return true}
                        }
                        return false;
                    });
                    if(invalidDates.length > 0){
                        dispatch(changeUpdatePolicyField(BAD_MSG, CONTENT_STRINGS.DATE_INPUT_NOT_VALID));
                        return false;
                    }

                    //validation for amounts
                    const invalidAmounts = policyUpdateAnswersDtos.filter(item => {
                        if (item.amount && formData[item.questionId]) {
                            const errMsg = validateAmount(formData[item.questionId], /* minimum if needed */);
                            if (errMsg !== '') {
                                dispatch(changeUpdatePolicyField(BAD_MSG, CONTENT_STRINGS.PLEASE_ENTER_VALID_AMOUNT_FOR + " " + updateTab.questions.find(q => q.id.toString() === item.questionId).name));
                            }
                            return errMsg !== '';
                        }
                        return false;
                    });

                   if (invalidAmounts.length > 0) {
                        return false;
                    }
                    const isTerminalStatus = policyUpdateAnswersDtos.find(answer =>
                        answer.questionMachineName === 'WhatCaseResult'
                        && TERMINAL_POLICY_STATUSES.includes(answer.optionMachineName)
                    );
                    if (hasProcessingAd && isTerminalStatus) {
                        dispatch(changeUpdatePolicyField(BAD_MSG, CONTENT_STRINGS.AD_PROCESSING_CASE_RESULT_ERROR));
                        return false;
                    }

                    // Remove duplicate files from question attachments
                    policyUpdateAnswersDtos = policyUpdateAnswersDtos.map(answer => {
                        if (answer.answerAttachments && answer.answerAttachments.length > 0) {
                            const uniqueAttachments = arrayUnique(answer.answerAttachments, NAME_FIELD);
                            return {
                                ...answer,
                                answerAttachments: uniqueAttachments
                            };
                        }
                        return answer;
                    });

                    sendBody = {
                        policyUpdateAnswersDtos: policyUpdateAnswersDtos,
                        applicationId: SelectedAppId,
                        attachments: attachments.length > 0
                            ? attachments.map(a => ({ ...a, tags: updateTab.tags }))
                            : [],
                        action: 'Updated'
                    };
                    dispatch(requestPostUpdatePolicyForm(sendBody));
                }
            }
            else if (action === CONTENT_STRINGS.NO_CHANGES) {
                dispatch(requestPostNoChangesUpdatePolicyForm({
                    applicationId: SelectedAppId,
                    action: action
                }));
            }
        }
    };

    const onDrop = async (files) => {
        const failedFiles = [];
        for (const file of files) {
            try {
                const attachment = await fileToObjectHandle(file);
                dispatch(updatePolicyAttachmentsChange(attachment));
            } catch (error) {
                console.log('Error reading file: ', file.name, error);
                failedFiles.push(file.name);
            }
        }
        if (failedFiles.length > 0) {
            dispatch(changeUpdatePolicyField(BAD_MSG, `Failed to upload: ${failedFiles.join(', ')}`));
        }
    };

    const handleRemoveAttachment = (attachment, index) => {
        const filtered = updateTab.attachments.filter((_, i) => i !== index);
        dispatch(changeUpdatePolicyField('attachments', filtered));
        if (filtered.length === 0) {
            dispatch(changeUpdatePolicyField('tags', ''));
        }
    };

    const _findResetIds = (question, answer) => {
        let ids = [];
        _.forEach(question.options, o => {
            if(o.id.toString() !== answer.toString()){
                _.forEach(o.childQuestions, cq => {
                    const matched =  findUpdateQuestionById(updateTab.questions, cq.id);
                    ids.push(matched.id);
                    ids =  [...ids, ..._findResetIds(matched, answer)]
                });
            }
        });
        return ids;
    };

    const _calculateFormData = (changedFieldId, changedFieldValue) => {
        let triggeredQuestion = findUpdateQuestionById(updateTab.questions, changedFieldId);
        if(!triggeredQuestion) return {...updateTab.formData};
        let idsToReset = _findResetIds(triggeredQuestion, changedFieldValue);
        return _.mapValues(updateTab.formData, (data, key) => {
            return idsToReset.includes(parseInt(key))?'':data;
        });
    };

    const handleSelectChange = (evt) => {
        dispatch(changeUpdatePolicyField('formData', _calculateFormData(evt.target.name, evt.target.value)));
        dispatch(changeUpdatePolicyFormData(evt.target.name, evt.target.value));
    };

    const handleMultipleQuestionFiles = async (evt,questionId) => {
        const questionFiles = await Promise.all(evt.map(async (file) => {
            return await fileToObjectHandle(file);
          }));
        const existingFiles = updateTab.formData[questionId] || [];
        // Remove duplicate files based on file name
        const newValue = arrayUnique([...existingFiles, ...questionFiles], NAME_FIELD);
        dispatch(changeUpdatePolicyFormData(questionId, newValue));
    };

    const handleSingleFileQuestions = async (evt,questionId) => {
        const questionFiles = await Promise.all(evt.map(async (file) => {
            return await fileToObjectHandle(file);
          }));
        dispatch(changeUpdatePolicyFormData(questionId, questionFiles));
    };

    const handleDateChange = (name, value, minDate, maxDate) => {
        if (!value) { //if value is  undefined
            if (name.target.value.length >= 8) {
                let split = name.target.value.split('/');
                if (split.length === 3) {
                    if (split[2].length === 4) {
                        let d = getHtmlValidDate(name.target.value);

                        if (!name.target.value.match(DATE_REGURAL_EXPRESSION)) { //if the date is invalid
                            dispatch(changeUpdatePolicyFormData(name.target.name, ''));
                            return false;
                        }
                        else {
                            if (minDate) { //if minDate exists
                                let t = getHtmlValidDate(minDate);
                                if (moment(d).isBefore(t)) {
                                    dispatch(changeUpdatePolicyFormData(name.target.name, ''));
                                    return false;
                                }
                            }
                            if (maxDate) { //if max date exists
                                let t = getHtmlValidDate(maxDate);
                                if (moment(d).isAfter(t)) {
                                    dispatch(changeUpdatePolicyFormData(name.target.name, ''));
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }

        let foundQuestion;
        if(value){
            foundQuestion = findQuestionById(name, updateTab.questions);
        } else {
            foundQuestion = findQuestionById(name.target.name, updateTab.questions);
        }

        if(foundQuestion){
            const minDate = getDateQuestionMinimumValue(foundQuestion, updateTab.formData, updateTab.questions);
            const maxDate = getDateQuestionMaximumValue(foundQuestion, updateTab.formData, updateTab.questions);
            let answer = value ? value : name.target.value;
            if(
                answer
                && (
                    (minDate && answer < minDate)
                    || (maxDate && answer > maxDate)
                )
            ) {
                dispatch(changeUpdatePolicyFormData(foundQuestion.id, ''))
            }
        }

        value !== undefined ? //when user wants to clear the date the value is undefined
            (dispatch(changeUpdatePolicyFormData(name, value))) : dispatch(changeUpdatePolicyFormData(name.target.name, name.target.value));
    };

    //if the user marks update question : is case closed as Yes then, the following question should not be mandatory
    const shouldUpdateQuestionBeMandatory = (question) => {
        if(COUNTRY == CANADA_COUNTRY){
            if(question.machineName === HAS_LAWYER_CHANGED_SINCE_LAST_UPDATE_MN) {return true}
            if(question.machineName === CONFIRM_DEFENDANTS_INSURERS_MN) {return true}
            if(question.machineName === NAME_OF_INSURER_MN) {return true}
        }
        if(question.machineName === CONFIRM_FEE_EARNER_CURRENTLY_RESPONSIBLE_MN) {return true}

        if(question.machineName === FEE_EARNER_EMAIL_MN) {return true}

        if(question.machineName === IS_CASE_CLOSED_MN) {return true}

        if(question.machineName === CURRENT_LITIGATION_STAGE_MN) {return true}

        if(question.machineName === OTHER_RESULT_INFO_MN) {return true}

        return true
    };

    return (
        <UpdateTab
            onDropSingle={handleSingleFileQuestions}
            onDropMultiple={handleMultipleQuestionFiles}
            shouldUpdateQuestionBeMandatory={shouldUpdateQuestionBeMandatory}
            userRoles={user.loggedInUser.roles}
            applicationStatusMachineName={applicationStatusMachineName}
            UserRole={UserRole}
            HandleInputChange={(field, value) => dispatch(changeUpdatePolicyField(field, value))}
            HandleSubmit={handleUpdateTabSubmit}
            HandleSelectChange={handleSelectChange}
            HandleDateChange={handleDateChange}
            HandleFormCompChange={(field, value) => dispatch(changeUpdatePolicyFormData(field, value))}
            OnDrop={onDrop}
            HandleRemoveAttachment={handleRemoveAttachment}
            Store={updateTab}
            hasProcessingAd={hasProcessingAd}
            pigApplied={pigApplied}
        />
    );
};

export default UpdateTabHOC;